import Masonry from 'masonry-layout'
import '../../css/external/masonry.scss';

export default Masonry;